import React from "react";
import Image from "@components/Image";
import Markdown from "@components/Markdown";
import styles from "./SectionContent.module.scss";
import cx from "classnames";
import _ from "lodash";
const components = {
  p: (props: any) => <p {...props} className={cx(props.className, "mb-4")} />,
};
const View = ({
  type = "left",
  image = {},
  content = "",
  title = "",
  border = "",
  className,
}: any) => {
  return (
    <section
      data-scroll-section
      className={cx("inner-large", styles.section, styles[type], className)}
    >
      <div
        className={cx(styles.contentBox, {
          [styles.borderNone]: border === "none",
        })}
      >
        <div className={styles.box}>
          <div className={cx("ama-section-title capitalize", styles.title)}>
            {!!title && title}
          </div>
          <div className={cx("ama-content", styles.content)}>
            {!!content && (
              <Markdown components={components} content={content} />
            )}
          </div>
        </div>
      </div>
      <div className={styles.imgBox}>
        <Image
          wrapperProps={{ className: cx(styles.img) }}
          src={_.get(image, "src")}
          alt={_.get(image, "alt")}
          layout="fill"
          objectFit="cover"
          scale="1.2"
        />
      </div>
    </section>
  );
};
export default View;
